import React, { useState } from 'react';
import { Truck, Package, CheckCircle2, AlertCircle, Search, Plus, ArrowRight, FileText, MoreVertical, Calendar, User, MapPin, X, DollarSign, Trash2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ReceivingModule() {
  const [isReceiving, setIsReceiving] = useState(false);
  const [isBlindModalOpen, setIsBlindModalOpen] = useState(false);
  const [blindData, setBlindData] = useState({
    vendor: 'Sysco Foods',
    invoiceNumber: '',
    dateReceived: new Date().toISOString().split('T')[0],
    items: [{
      id: '1',
      name: '',
      qty: 0,
      unit: 'Case',
      price: 0
    }],
    notes: ''
  });
  const addItem = () => {
    setBlindData({
      ...blindData,
      items: [...blindData.items, {
        id: Math.random().toString(36).substr(2, 9),
        name: '',
        qty: 0,
        unit: 'Case',
        price: 0
      }]
    });
  };
  const removeItem = (id: string) => {
    setBlindData({
      ...blindData,
      items: blindData.items.filter(item => item.id !== id)
    });
  };
  const updateItem = (id: string, field: string, value: any) => {
    setBlindData({
      ...blindData,
      items: blindData.items.map(item => item.id === id ? {
        ...item,
        [field]: value
      } : item)
    });
  };
  const calculateTotal = () => {
    return blindData.items.reduce((sum, item) => sum + item.qty * item.price, 0);
  };
  if (isReceiving) {
    return <div className="space-y-6" data-id="element-937">
        <div className="flex items-center justify-between" data-id="element-938">
          <div className="flex items-center gap-4" data-id="element-939">
            <button onClick={() => setIsReceiving(false)} className="p-2 hover:bg-slate-100 rounded-xl transition-colors text-slate-400" data-id="element-940">
              <ArrowRight size={20} className="rotate-180" data-id="element-941" />
            </button>
            <div data-id="element-942">
              <h3 className="text-xl font-black text-slate-900" data-id="element-943">
                Process Delivery
              </h3>
              <p className="text-sm font-bold text-slate-500" data-id="element-944">
                PO-2025-001 • Sysco Foods
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-945">
            <button className="px-6 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-946">
              Reject Delivery
            </button>
            <button className="px-6 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-947">
              Approve Receiving
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-948">
          <div className="md:col-span-2 space-y-4" data-id="element-949">
            <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-950">
              <div className="p-4 border-b border-slate-50 bg-slate-50/30 flex items-center justify-between" data-id="element-951">
                <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-952">
                  Items Received
                </h4>
                <button className="text-emerald-600 text-[10px] font-black hover:underline uppercase" data-id="element-953">
                  Mark All Received
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-954">
                <table className="w-full text-left border-collapse" data-id="element-955">
                  <thead data-id="element-956">
                    <tr className="border-b border-slate-100" data-id="element-957">
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-958">
                        Item
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-959">
                        Ordered
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-960">
                        Received
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-961">
                        MIS PIC?
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-962">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50" data-id="element-963">
                    {[1, 2, 3].map(i => <tr key={i} className="hover:bg-slate-50/50 transition-colors" data-id="element-964">
                        <td className="px-6 py-4" data-id="element-965">
                          <p className="text-sm font-bold text-slate-900" data-id="element-966">
                            Inventory Item {i}
                          </p>
                          <p className="text-[10px] text-slate-400 font-medium" data-id="element-967">
                            $1.50 / unit
                          </p>
                        </td>
                        <td className="px-6 py-4 text-center text-sm font-bold text-slate-500" data-id="element-968">
                          10
                        </td>
                        <td className="px-6 py-4" data-id="element-969">
                          <div className="flex justify-center" data-id="element-970">
                            <input type="number" defaultValue={10} className="w-20 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-center text-sm font-bold focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all" data-id="element-971" />
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-972">
                          <div className="flex justify-center" data-id="element-973">
                            <input type="checkbox" className="w-4 h-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500" data-id="element-974" />
                          </div>
                        </td>
                        <td className="px-6 py-4 text-right" data-id="element-975">
                          <CheckCircle2 size={16} className="text-emerald-500 ml-auto" data-id="element-976" />
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="md:col-span-1 space-y-6" data-id="element-977">
            <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm space-y-4" data-id="element-978">
              <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-979">
                Delivery Header
              </h4>
              <div className="space-y-3" data-id="element-980">
                <div data-id="element-981">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-982">
                    Delivery Note #
                  </label>
                  <input type="text" className="w-full px-4 py-2 bg-slate-50 border-none rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none" placeholder="e.g. DN-9982" data-id="element-983" />
                </div>
                <div data-id="element-984">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-985">
                    Received By
                  </label>
                  <div className="flex items-center gap-2 p-2 bg-slate-50 rounded-xl" data-id="element-986">
                    <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center text-[10px] font-black text-emerald-600" data-id="element-987">
                      AJ
                    </div>
                    <span className="text-xs font-bold text-slate-700" data-id="element-988">
                      Adeel Jabbar
                    </span>
                  </div>
                </div>
                <div data-id="element-989">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-990">
                    Location
                  </label>
                  <select className="w-full px-4 py-2 bg-slate-50 border-none rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none appearance-none" data-id="element-991">
                    <option data-id="element-992">Walk In</option>
                    <option data-id="element-993">Freezer</option>
                    <option data-id="element-994">Liquor Room</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="bg-slate-900 p-6 rounded-2xl text-white shadow-xl space-y-6" data-id="element-995">
              <h4 className="text-sm font-bold uppercase tracking-wider" data-id="element-996">
                Receiving Summary
              </h4>
              <div className="space-y-4" data-id="element-997">
                <div className="flex items-center justify-between text-slate-400" data-id="element-998">
                  <span className="text-xs font-bold uppercase tracking-widest" data-id="element-999">
                    PO Total
                  </span>
                  <span className="text-sm font-bold" data-id="element-1000">$1,450.25</span>
                </div>
                <div className="flex items-center justify-between text-slate-400" data-id="element-1001">
                  <span className="text-xs font-bold uppercase tracking-widest" data-id="element-1002">
                    Received Total
                  </span>
                  <span className="text-sm font-bold text-white" data-id="element-1003">
                    $1,425.00
                  </span>
                </div>
                <div className="pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-1004">
                  <span className="text-sm font-black uppercase tracking-widest" data-id="element-1005">
                    Variance
                  </span>
                  <span className="text-xl font-black text-rose-400" data-id="element-1006">
                    -$25.25
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="space-y-6" data-id="element-1007">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1008">
        <div className="flex items-center gap-4 flex-1 max-w-2xl" data-id="element-1009">
          <div className="relative flex-1" data-id="element-1010">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-1011" />
            <input type="text" placeholder="Search open orders..." className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" data-id="element-1012" />
          </div>
        </div>
        <button onClick={() => setIsBlindModalOpen(true)} className="flex items-center gap-2 px-6 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-1013">
          <Plus size={16} data-id="element-1014" />
          Blind Receiving
        </button>
      </div>

      <AnimatePresence data-id="element-1015">
        {isBlindModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1016">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-1017">
              <div className="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-1018">
                <div data-id="element-1019">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-1020">
                    Blind Receiving Goods
                  </h3>
                  <p className="text-sm text-slate-500 font-medium" data-id="element-1021">
                    Record incoming goods without a pre-existing PO
                  </p>
                </div>
                <button onClick={() => setIsBlindModalOpen(false)} className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400 hover:text-slate-600" data-id="element-1022">
                  <X size={20} data-id="element-1023" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-8" data-id="element-1024">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1025">
                  <div data-id="element-1026">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1027">
                      Vendor
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={blindData.vendor} onChange={e => setBlindData({
                  ...blindData,
                  vendor: e.target.value
                })} data-id="element-1028">
                      <option data-id="element-1029">Sysco Foods</option>
                      <option data-id="element-1030">Profish</option>
                      <option data-id="element-1031">Washington Wholesales</option>
                      <option data-id="element-1032">US Foods</option>
                      <option data-id="element-1033">Local Farmers</option>
                    </select>
                  </div>
                  <div data-id="element-1034">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1035">
                      Invoice / DN #
                    </label>
                    <input type="text" placeholder="e.g. INV-8821" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={blindData.invoiceNumber} onChange={e => setBlindData({
                  ...blindData,
                  invoiceNumber: e.target.value
                })} data-id="element-1036" />
                  </div>
                  <div data-id="element-1037">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1038">
                      Date Received
                    </label>
                    <div className="relative" data-id="element-1039">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-1040" />
                      <input type="date" className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={blindData.dateReceived} onChange={e => setBlindData({
                    ...blindData,
                    dateReceived: e.target.value
                  })} data-id="element-1041" />
                    </div>
                  </div>
                </div>

                <div className="space-y-4" data-id="element-1042">
                  <div className="flex items-center justify-between" data-id="element-1043">
                    <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-1044">
                      Received Items
                    </h4>
                    <button onClick={addItem} className="flex items-center gap-1 text-xs font-bold text-emerald-600 hover:text-emerald-700 transition-colors" data-id="element-1045">
                      <Plus size={14} data-id="element-1046" /> Add Item
                    </button>
                  </div>

                  <div className="bg-slate-50 rounded-2xl border border-slate-100 overflow-hidden" data-id="element-1047">
                    <table className="w-full text-left border-collapse" data-id="element-1048">
                      <thead data-id="element-1049">
                        <tr className="border-b border-slate-200" data-id="element-1050">
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1051">
                            Item Name
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-24" data-id="element-1052">
                            Qty Recv
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-32" data-id="element-1053">
                            Unit
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-32" data-id="element-1054">
                            Unit Cost
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-32 text-right" data-id="element-1055">
                            Total
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-12" data-id="element-1056"></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100" data-id="element-1057">
                        {blindData.items.map(item => <tr key={item.id} className="bg-white/50" data-id="element-1058">
                            <td className="px-4 py-2" data-id="element-1059">
                              <input type="text" placeholder="Item name..." className="w-full bg-transparent text-sm font-bold outline-none focus:text-emerald-600" value={item.name} onChange={e => updateItem(item.id, 'name', e.target.value)} data-id="element-1060" />
                            </td>
                            <td className="px-4 py-2" data-id="element-1061">
                              <input type="number" className="w-full bg-transparent text-sm font-bold outline-none" value={item.qty} onChange={e => updateItem(item.id, 'qty', Number(e.target.value))} data-id="element-1062" />
                            </td>
                            <td className="px-4 py-2" data-id="element-1063">
                              <select className="w-full bg-transparent text-sm font-bold outline-none" value={item.unit} onChange={e => updateItem(item.id, 'unit', e.target.value)} data-id="element-1064">
                                <option data-id="element-1065">Case</option>
                                <option data-id="element-1066">Each</option>
                                <option data-id="element-1067">Pound</option>
                                <option data-id="element-1068">Gallon</option>
                                <option data-id="element-1069">Bottle</option>
                              </select>
                            </td>
                            <td className="px-4 py-2" data-id="element-1070">
                              <div className="flex items-center gap-1" data-id="element-1071">
                                <span className="text-slate-400" data-id="element-1072">$</span>
                                <input type="number" className="w-full bg-transparent text-sm font-bold outline-none" value={item.price} onChange={e => updateItem(item.id, 'price', Number(e.target.value))} data-id="element-1073" />
                              </div>
                            </td>
                            <td className="px-4 py-2 text-right text-sm font-black text-slate-900" data-id="element-1074">
                              ${(item.qty * item.price).toFixed(2)}
                            </td>
                            <td className="px-4 py-2 text-right" data-id="element-1075">
                              <button onClick={() => removeItem(item.id)} className="p-1 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-1076">
                                <Trash2 size={14} data-id="element-1077" />
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1078">
                  <div data-id="element-1079">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1080">
                      Receiving Notes / Discrepancies
                    </label>
                    <textarea rows={3} placeholder="Note any damaged items or shortages..." className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all resize-none" value={blindData.notes} onChange={e => setBlindData({
                  ...blindData,
                  notes: e.target.value
                })} data-id="element-1081" />
                  </div>
                  <div className="bg-emerald-500 rounded-2xl p-6 flex flex-col justify-center items-end text-white shadow-lg shadow-emerald-500/20" data-id="element-1082">
                    <p className="text-xs font-bold opacity-60 uppercase tracking-widest mb-1" data-id="element-1083">
                      Total Received Value
                    </p>
                    <p className="text-4xl font-black" data-id="element-1084">
                      ${calculateTotal().toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="px-8 py-6 border-t border-slate-100 bg-slate-50/50 flex items-center justify-end gap-3" data-id="element-1085">
                <button onClick={() => setIsBlindModalOpen(false)} className="px-6 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-200 rounded-xl transition-all" data-id="element-1086">
                  Cancel
                </button>
                <button onClick={() => setIsBlindModalOpen(false)} className="px-8 py-2.5 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-1087">
                  Complete Receiving
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      <div className="grid grid-cols-1 gap-4" data-id="element-1088">
        {[1, 2].map(i => <div key={i} className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden hover:border-emerald-200 transition-all group" data-id="element-1089">
            <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-1090">
              <div className="flex items-start gap-4" data-id="element-1091">
                <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600" data-id="element-1092">
                  <Truck size={24} data-id="element-1093" />
                </div>
                <div data-id="element-1094">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1095">
                    <h4 className="text-lg font-black text-slate-900" data-id="element-1096">
                      PO-2025-00{i}
                    </h4>
                    <span className="px-2 py-0.5 bg-blue-50 text-blue-600 text-[10px] font-black rounded uppercase border border-blue-100" data-id="element-1097">
                      Submitted
                    </span>
                  </div>
                  <p className="text-sm font-bold text-slate-500" data-id="element-1098">
                    Sysco Foods • Expected Today
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1099">
                <button onClick={() => setIsReceiving(true)} className="flex items-center gap-2 px-6 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-md" data-id="element-1100">
                  Start Receiving
                  <ArrowRight size={16} data-id="element-1101" />
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}